(ns minorodata.analytics.subs
  (:require
   [minorodata.app.utils :as app.utils]
   [minorodata.utils :refer [find-first]]
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 :analytics.subs/summary
 (fn [db]
   (get-in db [:analytics :summary])))

(re-frame/reg-sub
 :analytics.subs/connectors-summary
 (fn []
   (re-frame/subscribe [:analytics.subs/summary]))
 (fn [summary]
   (get summary :connectors)))

(re-frame/reg-sub
 :analytics.subs/db-connectors-summary
 (fn []
   (re-frame/subscribe [:analytics.subs/summary]))
 (fn [summary]
   (get summary :db-connectors)))


(re-frame/reg-sub
 :analytics.subs/summary-extracts
 (fn []
   (re-frame/subscribe [:analytics.subs/summary]))
 (fn [summary]
   (get summary :extracts)))

(re-frame/reg-sub
 :analytics.subs/summary-transforms
 (fn []
   (re-frame/subscribe [:analytics.subs/summary]))
 (fn [summary]
   (get summary :transforms)))

(re-frame/reg-sub
 :analytics.subs/summary-activity
 (fn []
   (re-frame/subscribe [:analytics.subs/summary]))
 (fn [summary]
   (get summary :current-activity)))


(re-frame/reg-sub
 :analytics.subs/timeframe
 (fn [db]
   (get-in db [:analytics :timeframe])))

(re-frame/reg-sub
 :analytics.subs/source-preferences
 (fn []
   (re-frame/subscribe [:users.subs/preferences]))
 (fn [preferences]
   (get-in preferences [:analytics :visible-sources] [])))

(re-frame/reg-sub
 :analytics.subs/visible-sources
 (fn []
   [(re-frame/subscribe [:analytics.subs/source-preferences])
    (re-frame/subscribe [:sources-panel/pull '[* {:sources-panel/sources [*]}]])
    (re-frame/subscribe [:connections.subs/all-connectors])])
 (fn [[source-ids {:sources-panel/keys [sources]} connectors]]
   (let [sources (sort-by :source/order sources)
         ;; Until sources load (or if the fetch fails) every saved ID would look unavailable.
         source-ids (if (seq sources) (distinct (remove nil? source-ids)) [])]
     (->> (concat (mapv (fn [id]
                          (or (find-first #(= id (:source/source-id %)) sources)
                              {:source/source-id id :unavailable? true}))
                        source-ids)
                  (take (- 5 (count source-ids))
                        (filter (fn [source] (not (some #(= (:source/source-id source) %) source-ids)))
                                sources)))
          (mapv (fn [s]
                  (assoc s
                         :connector (app.utils/find-connector-by-type-and-version connectors (:source/source-type s) (get-in s [:source/source :version])))))))))
